import React, { useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Link from '@material-ui/core/Link'

import MainUi from './components/MainUI'

import BrowserStore from 'store'
import { connect } from 'react-redux'

import { useQueryParam, StringParam, withQueryParams } from 'use-query-params'
// import { getAccessTokenSuccess } from "./actions/";
import axios from 'axios'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

require('dotenv').config()

const lessThanOneHourAgo = (date) => {
  const HOUR = 1000 * 60 * 60
  const anHourAgo = Date.now() - HOUR

  return date > anHourAgo
}

// function App() {

const App = (props) => {
  const API_HOST = process.env.REACT_APP_CANVAS_API_HOST
  const CANVAS_CLIENT_ID = process.env.REACT_APP_CANVAS_CLIENT_ID
  const CANVAS_CLIENT_SECRET = process.env.REACT_APP_CANVAS_CLIENT_SECRET
  const APP_URL = process.env.REACT_APP_APP_URL
  const CANVAS_DOMAIN = process.env.REACT_APP_CANVAS_DOMAIN

  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL

  const [authToken, setCode] = useQueryParam('code', StringParam)

  let [isLoggedIn, setIsLoggedIn] = React.useState(false)

  let inseadCanvasAdmin = BrowserStore.get('inseadCanvasAdmin')

  let welcomePage = BrowserStore.get('inseadCanvasAdminWelcome')

  let inseadCanvasAdminError = BrowserStore.get('inseadCanvasAdminError')

  let errorMessage = {
    heading: 'Authenticating',
    body: 'Please wait while we authenticate.'
  }

  // force redirect to login page.
  // if (typeof inseadCanvasAdmin == "undefined" && typeof authToken == "undefined") {
  //   window.location.href = `${BACKEND_URL}api/auth/login`;
  // }

  if (typeof welcomePage == 'undefined') {
    welcomePage = true
    BrowserStore.set('inseadCanvasAdminWelcome', true)
  }

  if (inseadCanvasAdminError) {
    errorMessage = inseadCanvasAdminError
  }

  const clickWelcomeLogin = () => {
    BrowserStore.set('inseadCanvasAdminWelcome', false)

    let scopes = [
      'url:GET|/api/v1/accounts/search',
      'url:GET|/api/v1/accounts/:account_id/courses',
      'url:GET|/api/v1/accounts/:account_id/sub_accounts',
      'url:GET|/api/v1/accounts/:account_id/roles',
      'url:POST|/api/v1/accounts/:account_id/sis_imports',
      'url:GET|/api/v1/accounts/:account_id/sis_imports/:id',
      'url:GET|/api/v1/accounts/:account_id/users',
      'url:GET|/api/v1/accounts/:account_id/terms'
    ]

    window.location.assign(`${BACKEND_URL}api/auth/login`)
  }

  useEffect(() => {
    if (inseadCanvasAdmin) {
      setIsLoggedIn(true)
    }
  }, [isLoggedIn])

  if (inseadCanvasAdmin) {
    let time = inseadCanvasAdmin.time

    let lessThanHr = lessThanOneHourAgo(time)

    // refresh token
    if (lessThanHr === false) {
      BrowserStore.remove('inseadCanvasAdmin')
      BrowserStore.remove('inseadCanvasAdminWelcome')
    } else {
      BrowserStore.set('inseadCanvasAdminWelcome', false)
    }
  }

  if (
    typeof authToken == 'undefined' &&
    typeof inseadCanvasAdmin == 'undefined' &&
    welcomePage == false
  ) {
    BrowserStore.remove('inseadCanvasAdminWelcome')
    BrowserStore.remove('inseadCanvasAdminError')
  }

  if (typeof inseadCanvasAdmin == 'undefined') {
    inseadCanvasAdmin = BrowserStore.get('inseadCanvasAdmin')

    if (typeof authToken != 'undefined') {
      let baseUrl = 'api/auth/token'

      let dataSet = {
        grant_type: 'authorization_code',
        client_id: CANVAS_CLIENT_ID,
        client_secret: CANVAS_CLIENT_SECRET,
        redirect_uri: `${API_HOST}?success`,
        code: authToken
      }

      axios
        .post(`${BACKEND_URL}${baseUrl}`, dataSet, { responseType: 'json' })
        .then((res) => {
          if (res.data != null && res.status == 200) {
            BrowserStore.set('inseadCanvasAdmin', {
              ...res.data,
              time: Date.now()
            })
            setIsLoggedIn(true)
            props.getAccessTokenSuccess({ payload: res.data.aaccess_token })
          } else {
            // throw new Error("Error Response - Contact IT support");
          }
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx

            if (error.response.status === 401) {
              BrowserStore.set(
                'inseadCanvasAdminError',
                (errorMessage = {
                  heading: 'User not found in LMS Admin',
                  body: 'Please contact <a class="MuiTypography-root MuiLink-root MuiLink-underlineHover MuiLink-button MuiTypography-body2 MuiTypography-colorPrimary" href="mailto:5555-ITservicedesk@insead.edu"> IT Support  </a> '
                })
              )
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
          } else {
            // Something happened in setting up the request that triggered an Error
          }

          window.location.href = APP_URL
        })
    }
  }

  let renderUI

  if (isLoggedIn && welcomePage == false) {
    renderUI = <MainUi />

    // renderUI = <ErrorPage/>
  } else if (welcomePage) {
    renderUI = (
      <div id='welcomeBg'>
        <div id='welcomeBox'>
          <h2> Welcome to LMS Admin </h2>

          <Button
            variant='outlined'
            size='large'
            color='primary'
            onClick={clickWelcomeLogin}
          >
            Login in with Insead
          </Button>
        </div>{' '}
      </div>
    )
  } else {
    renderUI = (
      <div id='welcomeBg'>
        <Dialog
          open={true}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {errorMessage.heading}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              <span dangerouslySetInnerHTML={{ __html: errorMessage.body }} />
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
    )
  }

  return (
    <Container disableGutters={true} maxWidth={false}>
      <Box>{renderUI}</Box>
    </Container>
  )
}

function mapStateToProps(state) {
  return {
    data: state.rootReducer
  }
}

export default connect(mapStateToProps, {})(App)
